var utils = require('../../utils')
import AppHeader from '../AppHeader'
import $ from "jquery"
global.jQuery = $;
window.jQuery = $;
export default {
  name: 'user-edit',
  created () {
    this.search()
  },
  data () {
    return {
      canValidate: true,
      searchCallbackFlag : false,
      savingFlag: false,
      magazine_ym_y: (new Date).getFullYear(),
      magazine_ym_m: ((new Date).getMonth() + 1),
      magazine: {
        magazine_title: null,
        magazine_ym: null,
        magazine_picture_path: null,
        magazine_pdf_path: null,
        magazine_picture: null,
        magazine_pdf: null,
        magazine_picture_filename: null,
        magazine_pdf_filename: null
      }
    }
  },
  computed: {
    magazineDetail: function() {
      return this.$store.getters.magazineDetailEdit
    },
    validation: function() {
      var v = {
        magazine_title: !!this.magazine.magazine_title,
        magazine_picture: !!this.magazine.magazine_picture || !!this.magazine.magazine_picture_path,
        magazine_pdf: !!this.magazine.magazine_pdf || !!this.magazine.magazine_pdf_path,
        not_input: !!this.magazine.magazine_title &&
                   (!!this.magazine.magazine_picture || !!this.magazine.magazine_picture_path) &&
                   (!!this.magazine.magazine_pdf || !!this.magazine.magazine_pdf_path)
      }
      if (!this.canValidate) {
        Object.keys(v).forEach(key => { v[key] = true; });
      }
      return v
    },
    isValid () {
      var validation = this.validation
      return Object.keys(validation).every(function (key) {
        return validation[key]
      })
    },
    getMagazineYm() {
      this.magazine.magazine_ym = (this.magazine_ym_y * 100) + this.magazine_ym_m
    },
    getMagazineYears() {
      var ret = []
      var counts = 11
      for (var i=0; i<counts; i++) {
        var dt = new Date()
        dt.setFullYear(dt.getFullYear() + i - 10)
        ret.push(dt.getFullYear())
      }
      return ret
    },
    loading () {
      return this.$store.getters.apiLoading
    },
    authToken() {
      return window.localStorage.getItem('access_token')
    },
    timeStamp() {
      var d = new Date()
      var year  = d.getFullYear()
      var month = d.getMonth() + 1
      var day   = d.getDate()
      var hour  = (d.getHours() < 10) ? '0' + d.getHours()   : d.getHours()
      var min   = (d.getMinutes() < 10) ? '0' + d.getMinutes() : d.getMinutes()
      var sec   = (d.getSeconds() < 10) ? '0' + d.getSeconds() : d.getSeconds()
      return year +''+ month +''+ day +''+ hour +''+ min +''+ sec
    }
  },
  components: {
    AppHeader
  },
  methods: {
    search: function() {
      var data = {}
      var self = this
      var callback = function () {
        self.searchCallbackFlag = true
        self.magazine.magazine_title = self.magazineDetail.attributes['magazine-title']
        self.magazine.magazine_ym = self.magazineDetail.attributes['magazine-ym']
        self.magazine_ym_y = parseInt(self.magazineDetail.attributes['magazine-ym']/100)
        self.magazine_ym_m = parseInt(self.magazineDetail.attributes['magazine-ym']%100)
        self.magazine.magazine_picture_path = self.magazineDetail.attributes['magazine-picture-path']
        self.magazine.magazine_pdf_path = self.magazineDetail.attributes['magazine-pdf-path']
      }
      this.$store.dispatch('MAGAZINE_EDIT',  { id: this.$route.params.id, data: data, callback: callback })
    },
    selectedMagazinePicture: function (event) {
      if (event) {
        var files = event.target.files
        this.magazine.magazine_picture = files[0]
      }
    },
    selectedMagazinePdf: function (event) {
      if (event) {
        var files = event.target.files
        this.magazine.magazine_pdf = files[0]
      }
    },
    onClickCancel: function () {
      this.$router.push('/magazines')
    },
    onClickSave: function () {
      if (this.savingFlag) return false
      var data = {}
      this.canValidate = true
      if (this.isValid) {
        this.savingFlag = true
        var form = new FormData()
        form.append('magazine_title', this.magazine.magazine_title)
        form.append('magazine_ym', this.magazine.magazine_ym)
        if (this.magazine.magazine_picture) {
          form.append('magazine_picture', this.magazine.magazine_picture)
        }
        if (this.magazine.magazine_pdf) {
          form.append('magazine_pdf', this.magazine.magazine_pdf)
        }
        this.$store.dispatch('MAGAZINE_UPDATE', {
          data: form,
          callback: this.onSaved,
          id: this.$route.params.id,
          errorCallback: this.onSaved
        })
      } else {
        console.log("need edit")
      }
    },
    onSaved: function (result) {
      this.savingFlag = false
      this.$router.push('/magazines')
    },
    onClickImageModalShow: function () {
      var button = document.getElementById('imageModalButton')
      var img    = document.getElementById('imageModalImg')
      var text   = document.getElementById('imageModalText')
      img.src = this.magazine.magazine_picture_path + '?token=' + this.authToken + '&timestamp=' + this.timeStamp
      text.textContent = ''
      button.click() // モーダル表示 イベント発火
    },
    goMagazinePdf: function(path) {
      return path + '?token=' + this.authToken + '&timestamp=' + this.timeStamp
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/magazine-edit.js